import { useQuery, useQueryClient } from '@tanstack/react-query';
export const AppUpgradeConfirmationKey = [
    'show-app-upgrade-confirmation'
];
export const useAppUpgradeConfirmationQuery = (queryOptions = {})=>{
    var _queryClient_getQueryData;
    const queryClient = useQueryClient();
    const value = (_queryClient_getQueryData = queryClient.getQueryData(AppUpgradeConfirmationKey)) !== null && _queryClient_getQueryData !== void 0 ? _queryClient_getQueryData : false;
    return useQuery(AppUpgradeConfirmationKey, ()=>value, {
        ...queryOptions
    });
};
